/* eslint-disable */

<template>
  <div class="vx-row Lgx202142297964412928">
    <div class="vx-col w-full">
      <vx-card class="mb-8">
        <div class="fourth-sim pt-0">
          <div class="vx-row mb-4">
            <div class="vx-col w-1/4 flex items-center" v-for="(item, index) in App" :key="index">
              <h2 class="font-bold">{{ item.name }}</h2>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-1/4 flex flex-col justify-center p-3" v-for="(column, cid) in App" :key="cid">
              <div v-for="(item, index) in column.options" :key="index" class="border-2 border-solid rounded p-2 mb-3 break-all cursor-pointer"
                   :class="item.selected ? 'bg-primary' : ''"
                   @click="item.selected = !item.selected">
                <div class="flex justify-between items-center">
                  {{item.name}}
                  <feather-icon v-if="item.correct && item.answer === true && item.correct === true" icon="CheckCircleIcon" svgClasses="w-6 h-6 " class="mr-1"></feather-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>

    </div>
  </div>
</template>

<script>

import vSelect from 'vue-select'
import Prism from 'vue-prism-component'
import shuffle from 'shuffle-array'

export default {
  data () {
    return {

      dataLocal: JSON.parse(JSON.stringify(this.data)),
      updateIndex: 0,

      App: [
        {
          name: 'Traditional IT',
          options: [
            {
              name: 'Applications',
              selected: false,
              answer: true,
              correct: null
            },
            {
              name: 'Runtimes',
              selected: false,
              answer: true,
              correct: null
            },
            {
              name: 'Security & Integration',
              selected: false,
              answer: true,
              correct: null
            },
            {
              name: 'Database',
              selected: false,
              answer: true,
              correct: null
            },
            {
              name: 'Servers',
              selected: false,
              answer: true,
              correct: null
            },
            {
              name: 'Virtualization',
              selected: false,
              answer: true,
              correct: null
            },
            {
              name: 'Server HW',
              selected: false,
              answer: true,
              correct: null
            },
            {
              name: 'Storage',
              selected: false,
              answer: true,
              correct: null
            },
            {
              name: 'Networking',
              selected: false,
              answer: true,
              correct: null
            }
          ]
        },
        {
          name: 'IaaS',
          options: [
            {
              name: 'Applications',
              selected: false,
              answer: true,
              correct: null
            },
            {
              name: 'Runtimes',
              selected: false,
              answer: true,
              correct: null
            },
            {
              name: 'Security & Integration',
              selected: false,
              answer: true,
              correct: null
            },
            {
              name: 'Database',
              selected: false,
              answer: true,
              correct: null
            },
            {
              name: 'Servers',
              selected: false,
              answer: true,
              correct: null
            },
            {
              name: 'Virtualization',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Server HW',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Storage',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Networking',
              selected: false,
              answer: false,
              correct: null
            }
          ]
        },
        {
          name: 'PaaS',
          options: [
            {
              name: 'Applications',
              selected: false,
              answer: true,
              correct: null
            },
            {
              name: 'Runtimes',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Security & Integration',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Database',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Servers',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Virtualization',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Server HW',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Storage',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Networking',
              selected: false,
              answer: false,
              correct: null
            }
          ]
        },
        {
          name: 'Saas',
          options: [
            {
              name: 'Applications',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Runtimes',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Security & Integration',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Database',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Servers',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Virtualization',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Server HW',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Storage',
              selected: false,
              answer: false,
              correct: null
            },
            {
              name: 'Networking',
              selected: false,
              answer: false,
              correct: null
            }
          ]
        }
      ]

    }
  },
  methods: {
    changePage (val) {
      if (val === 'next') {
        this.currentPage++
      }
      if (val === 'previous') {
        this.currentPage--
      }
    },
    markSimulation () {

      let total_score = 0


      this.App.forEach((x, i) => {
        x.options.forEach((y, i2) => {
          if (y.selected === y.answer) {
            this.App[i].options[i2].correct = true
            total_score++
          } else {
            this.App[i].options[i2].correct = false
          }
        })
      })


      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    }

  },
  components: {
    Prism,
    vSelect,
    shuffle
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  created () {
    this.App = shuffle(this.App)

    this.App.forEach((item, index) => {
      this.App[index].options = shuffle(item.options)
    })
  }

}
</script>
<style>

.Lgx202142297964412928 {

  font-size: 19px;

}

</style>
